import React, { useState, useEffect } from 'react';
import { APIURL } from '../../../configApi/apiConfig';
import axios from "../../../configApi/axiosConfig";
import { FormularioProtocolo } from './FormularioProtocolo';
const datosProtocolo = [
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Alto riesgo - Preventiva - Call Center',
        riesgo: 'ALTO RIESGO',
        cartera: 'PREVENTIVA',
        accion: 'CALL CENTER',
        dias_mora: 0
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Alto riesgo - Flujo - Visita Terrena',
        riesgo: 'ALTO RIESGO',
        cartera: 'FLUJO',
        accion: 'VISITA TERRENA',
        dias_mora: 5
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Alto riesgo - Primera - Jefe de Almacén',
        riesgo: 'ALTO RIESGO',
        cartera: 'PRIMERA',
        accion: 'JEFE DE ALMACEN',
        dias_mora: 30
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Mediano riesgo - Segunda - Call Center',
        riesgo: 'MEDIANO RIESGO',
        cartera: 'SEGUNDA',
        accion: 'CALL CENTER',
        dias_mora: 60
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Mediano riesgo - Tercera - WhatsApp',
        riesgo: 'MEDIANO RIESGO',
        cartera: 'TERCERA',
        accion: 'WHATSAPP',
        dias_mora: 90
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Mediano riesgo - Cuarta - Email',
        riesgo: 'MEDIANO RIESGO',
        cartera: 'CUARTA',
        accion: 'E-MAIL',
        dias_mora: 120
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Bajo riesgo - Quinta - SMS',
        riesgo: 'BAJO RIESGO',
        cartera: 'QUINTA',
        accion: 'SMS',
        dias_mora: 150
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Bajo riesgo - Sexta - Agente Virtual',
        riesgo: 'BAJO RIESGO',
        cartera: 'SEXTA',
        accion: 'AGENTE VIRTUAL',
        dias_mora: 180
    },
    {
        desde: '2026-02-01',
        hasta: '2026-02-28',
        descripcion: 'Bajo riesgo - Séptima - Email',
        riesgo: 'BAJO RIESGO',
        cartera: 'SEPTIMA',
        accion: 'E-MAIL',
        dias_mora: 360
    },
    {
        desde: '2026-03-01',
        hasta: '2026-03-28',
        descripcion: 'Bajo riesgo - Quinta - SMS',
        riesgo: 'BAJO RIESGO',
        cartera: 'QUINTA',
        accion: 'SMS',
        dias_mora: 150
    },
    {
        desde: '2026-03-01',
        hasta: '2026-03-28',
        descripcion: 'Bajo riesgo - Sexta - Agente Virtual',
        riesgo: 'BAJO RIESGO',
        cartera: 'SEXTA',
        accion: 'AGENTE VIRTUAL',
        dias_mora: 180
    },
    {
        desde: '2026-03-01',
        hasta: '2026-03-28',
        descripcion: 'Bajo riesgo - Séptima - Email',
        riesgo: 'BAJO RIESGO',
        cartera: 'SEPTIMA',
        accion: 'E-MAIL',
        dias_mora: 360
    }
];

const getRiesgoColor = (riesgo) => {
    switch (riesgo) {
        case 'ALTO RIESGO':
            return { bg: 'bg-red-50', text: 'text-red-700', badge: 'bg-red-100' };
        case 'MEDIANO RIESGO':
            return { bg: 'bg-amber-50', text: 'text-amber-700', badge: 'bg-amber-100' };
        case 'BAJO RIESGO':
            return { bg: 'bg-emerald-50', text: 'text-emerald-700', badge: 'bg-emerald-100' };
        default:
            return { bg: 'bg-slate-50', text: 'text-slate-700', badge: 'bg-slate-100' };
    }
};

const getRiesgoIcon = (riesgo) => {
    switch (riesgo) {
        case 'ALTO RIESGO':
            return '🔴';
        case 'MEDIANO RIESGO':
            return '🟡';
        case 'BAJO RIESGO':
            return '🟢';
        default:
            return '⚪';
    }
};

// Función para extraer año-mes únicos de los protocolos
const extraerMesesUnicos = (datos) => {
    const mesesSet = new Set();
    datos.forEach(item => {
        const mesAno = item.desde.substring(0, 7); // Extrae YYYY-MM
        mesesSet.add(mesAno);
    });
    return Array.from(mesesSet).sort();
};

export function GestionProtocolos() {
    const [datos, setDatos] = useState(datosProtocolo);
    const [riesgoData, setRiesgoData] = useState([]);
    const [riesgoSeleccionado, setRiesgoSeleccionado] = useState('');
    const [periodoSeleccionado, setPeriodoSeleccionado] = useState('');
    const [accionSeleccionada, setAccionSeleccionada] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [accionesDisponibles, setAccionesDisponibles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingData, setEditingData] = useState(null);
    const [filtrosAplicados, setFiltrosAplicados] = useState({
        riesgo: 0,
        periodo: '',
        accion: 0
    });

    useEffect(() => {
        fetchRiesgo();
        fetchAcciones();
    }, []);

    const fetchRiesgo = async () => {
        try {
            setLoading(true);
            const response = await axios.get(APIURL.cbo_riesgofindall());
            setRiesgoData(response.data || []);
        } catch (error) {
            console.error('Error al cargar riesgos:', error);
            setError('Error al cargar los riesgos');
            setRiesgoData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchAcciones = async () => {
        try {
            const response = await axios.get(APIURL.getcbo_acciones_all());
            setAccionesDisponibles(response.data);
        }
        catch (error) {
            console.error('Error al obtener acciones:', error);
            setAccionesDisponibles([]);
        }
    };

    const getInternoExternoLabel = (value) => {
        return value === 1 ? 'INTERNO' : value === 2 ? 'EXTERNO' : '';
    };

    const getTipoLabel = (value) => {
        return value === 1 ? 'TELEFONICO' : value === 2 ? 'TERRENO' : value === 3 ? 'TELEMATICO' : '';
    };

    const getAccionLabel = (idCbo) => {
        const accion = accionesDisponibles.find(a => a.idCbo_Acciones === idCbo);
        if (accion) {
            return `${accion.Accion} - ${getInternoExternoLabel(accion.InternoExterno)} - ${getTipoLabel(accion.Tipo)}`;
        }
        return idCbo || '-';
    };

    const isAccionSMS = (idAccion) => {
        const accion = accionesDisponibles.find(a => a.idCbo_Acciones == idAccion);
        return accion && accion.Accion === 'SMS';
    };

    const handleRiesgoChange = (e) => {
        setRiesgoSeleccionado(e.target.value);
    };

    const handlePeriodoChange = (e) => {
        setPeriodoSeleccionado(e.target.value);
    };

    const handleAccionChange = (e) => {
        setAccionSeleccionada(e.target.value);
    };

    const handleBuscar = () => {
        console.log('Aplicando filtros:', { 
            riesgo: riesgoSeleccionado ? parseInt(riesgoSeleccionado) : 0, 
            periodo: periodoSeleccionado, 
            accion: accionSeleccionada ? parseInt(accionSeleccionada) : 0
        });
        setFiltrosAplicados({
            riesgo: riesgoSeleccionado ? parseInt(riesgoSeleccionado) : 0,
            periodo: periodoSeleccionado,
            accion: accionSeleccionada ? parseInt(accionSeleccionada) : 0
        });
    };

    const handleLimpiarFiltros = () => {
        setRiesgoSeleccionado('');
        setPeriodoSeleccionado('');
        setAccionSeleccionada('');
        setFiltrosAplicados({
            riesgo: 0,
            periodo: '',
            accion: 0
        });
    };


    const handleEliminar = (desde) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este protocolo?')) {
            setDatos(datos.filter(item => item.desde !== desde));
        }
    };

    const handleEditar = (item) => {
        setEditingData(item);
        setIsModalOpen(true);
    };

    const handleNuevo = () => {
        setEditingData(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingData(null);
    };

    const handleSubmitProtocolo = (protocoData) => {
        if (editingData) {
            // Modo edición - actualizar registro existente
            setDatos(datos.map(item => 
                item.desde === editingData.desde ? { ...protocoData } : item
            ));
        } else {
            // Modo crear - agregar nuevo registro
            setDatos([...datos, protocoData]);
        }
    };

    const formatearFecha = (fechaString) => {
        const [year, month, day] = fechaString.split('-');
        const date = new Date(year, parseInt(month) - 1, parseInt(day));
        return date.toLocaleDateString('es-ES', { day: '2-digit', month: 'short' });
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="mb-12">
                    <div className="flex items-center gap-4 mb-2">
                        <div className="p-3 bg-gradient-to-br from-indigo-400 to-purple-400 rounded-full shadow-lg">
                            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-4xl font-bold text-gray-800">Estrategia de Cobranza</h1>
                            <p className="text-gray-500 text-sm mt-1">Gestión inteligente de protocolos y estrategias</p>
                        </div>
                    </div>
                </div>

                {/* Total */}
                <div className="mb-10">
                    <div className="flex items-center gap-6">
                        <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
                            <div className="flex items-center gap-6">
                                <div className="p-4 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-2xl">
                                    <span className="text-3xl">📋</span>
                                </div>
                                <div>
                                    <p className="text-gray-500 text-sm font-medium">Total de Protocolos</p>
                                    <p className="text-4xl font-bold text-indigo-600 mt-1">{datos.length}</p>
                                </div>
                            </div>
                        </div>

                        {/* Botón Nuevo Protocolo */}
                        <button
                            onClick={handleNuevo}
                            className="px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-3xl font-bold hover:from-green-600 hover:to-emerald-600 transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 flex items-center gap-3 text-lg"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            Nuevo Protocolo
                        </button>
                    </div>
                </div>

                {/* Filtros de Riesgo y Período */}
                <div className="mb-8 flex flex-col md:flex-row gap-4 w-full">
                    {/* Selector de Riesgo */}
                    <div className="w-full md:w-96">
                        <label className="block text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
                            Filtrar por Riesgo
                        </label>
                        <select
                            value={riesgoSeleccionado}
                            onChange={handleRiesgoChange}
                            disabled={loading}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-indigo-500 focus:ring-indigo-200 font-medium text-gray-700 transition-all bg-white hover:border-gray-300 disabled:bg-gray-100"
                        >
                            <option value="">Todos los riesgos</option>
                            {riesgoData && riesgoData.length > 0 ? (
                                riesgoData.map(r => (
                                    <option key={r.idCbo_Riesgo || r.id} value={r.idCbo_Riesgo || r.id}>
                                        {r.Riesgo || r.nombre}
                                    </option>
                                ))
                            ) : (
                                <option disabled>Cargando riesgos...</option>
                            )}
                        </select>
                    </div>

                    {/* Calendario de Período (Año-Mes) */}
                    <div className="w-full md:w-96">
                        <label className="block text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
                            📅 Filtrar por Período (Año-Mes)
                        </label>
                        <input
                            type="month"
                            value={periodoSeleccionado}
                            onChange={handlePeriodoChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-purple-500 focus:ring-purple-200 font-medium text-gray-700 transition-all bg-white hover:border-gray-300 cursor-pointer"
                        />
                    </div>

                    {/* Selector de Acción */}
                    <div className="w-full md:w-96">
                        <label className="block text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
                            🎯 Filtrar por Acción
                        </label>
                        <select
                            value={accionSeleccionada}
                            onChange={handleAccionChange}
                            disabled={loading}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-purple-500 focus:ring-purple-200 font-medium text-gray-700 transition-all bg-white hover:border-gray-300 disabled:bg-gray-100"
                        >
                            <option value="">Todas las acciones</option>
                            {accionesDisponibles && accionesDisponibles.length > 0 ? (
                                accionesDisponibles.map(accion => (
                                    <option key={accion.idCbo_Acciones} value={accion.idCbo_Acciones}>
                                        {accion.Accion} - {getInternoExternoLabel(accion.InternoExterno)} - {getTipoLabel(accion.Tipo)}
                                    </option>
                                ))
                            ) : (
                                <option disabled>Cargando acciones...</option>
                            )}
                        </select>
                    </div>

                    {/* Botones de búsqueda */}
                    <div className="flex gap-3 items-end">
                        <button
                            onClick={handleBuscar}
                            className="px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-xl font-bold hover:from-indigo-600 hover:to-purple-600 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center gap-2 h-fit"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            Buscar
                        </button>
                        <button
                            onClick={handleLimpiarFiltros}
                            className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200 transition-all duration-200 border-2 border-gray-300 flex items-center gap-2 h-fit"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            Limpiar
                        </button>
                    </div>
                </div>
                {error && <p className="text-red-500 text-xs mt-2">{error}</p>}

                {/* Tabla */}
                <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100 flex flex-col h-screen max-h-[600px]">
                    <div className="overflow-y-auto flex-1">
                        <table className="w-full">
                            <thead className="sticky top-0 bg-gradient-to-r from-indigo-50 via-purple-50 to-indigo-50 border-b border-gray-200 z-10">
                                <tr>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">Riesgo</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">Descripción</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">Cartera</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">Acción</th>
                                    <th className="px-6 py-4 text-center text-xs font-semibold text-indigo-700 uppercase tracking-wider">Días Mora</th>
                                    <th className="px-6 py-4 text-center text-xs font-semibold text-indigo-700 uppercase tracking-wider">Período</th>
                                    <th className="px-6 py-4 text-center text-xs font-semibold text-indigo-700 uppercase tracking-wider">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {(() => {
                                    let datosFiltered = datos;

                                    // Filtrar usando los filtros aplicados (ahora con IDs)
                                    if (filtrosAplicados.riesgo) {
                                        // Encontrar el nombre del riesgo por ID para comparar
                                        const riesgoObj = riesgoData.find(r => (r.idCbo_Riesgo || r.id) == filtrosAplicados.riesgo);
                                        if (riesgoObj) {
                                            const riesgoNombre = riesgoObj.Riesgo || riesgoObj.nombre;
                                            datosFiltered = datosFiltered.filter(item => item.riesgo === riesgoNombre);
                                        }
                                    }

                                    // Filtrar por período (año-mes)
                                    if (filtrosAplicados.periodo) {
                                        datosFiltered = datosFiltered.filter(item => {
                                            const mesAno = item.desde.substring(0, 7); // Extrae YYYY-MM
                                            return mesAno === filtrosAplicados.periodo;
                                        });
                                    }

                                    // Filtrar por acción (usando ID)
                                    if (filtrosAplicados.accion) {
                                        const accionObj = accionesDisponibles.find(a => a.idCbo_Acciones == filtrosAplicados.accion);
                                        if (accionObj) {
                                            datosFiltered = datosFiltered.filter(item => 
                                                item.accion && item.accion.toUpperCase() === accionObj.Accion.toUpperCase()
                                            );
                                        }
                                    }

                                    if (datosFiltered.length === 0) {
                                        return (
                                            <tr>
                                                <td colSpan="7" className="px-6 py-12 text-center">
                                                    <div className="flex flex-col items-center justify-center gap-3">
                                                        <span className="text-5xl">📭</span>
                                                        <p className="text-gray-500 text-sm font-medium">No hay protocolos que coincidan con los filtros seleccionados</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }

                                    return datosFiltered.map((item, idx) => {
                                        const riesgoStyle = getRiesgoColor(item.riesgo);
                                        const icon = getRiesgoIcon(item.riesgo);

                                        return (
                                            <tr
                                                key={idx}
                                                className={`border-b border-gray-100 hover:bg-indigo-50 transition-all duration-200`}
                                            >
                                                <td className="px-6 py-5 text-sm">
                                                    <span className={`inline-flex items-center gap-2 px-3 py-2 rounded-full ${riesgoStyle.badge} ${riesgoStyle.text} font-semibold text-xs`}>
                                                        <span className="text-base">{icon}</span>
                                                        {item.riesgo}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5 text-sm font-medium text-gray-700">
                                                    {item.descripcion}
                                                </td>
                                                <td className="px-6 py-5 text-sm text-gray-700">
                                                    <span className="inline-flex items-center px-3 py-2 rounded-full bg-blue-50 text-blue-700 font-semibold text-xs border border-blue-100">
                                                        {item.cartera}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5 text-sm text-gray-700">
                                                    <span className="inline-flex items-center px-3 py-2 rounded-full bg-purple-50 text-purple-700 font-semibold text-xs border border-purple-100">
                                                        {item.accion}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5 text-center text-sm font-semibold text-gray-700">
                                                    <span className={`inline-flex items-center px-3 py-2 rounded-full ${item.dias_mora === 0 ? 'bg-emerald-50 text-emerald-700 border border-emerald-100' :
                                                        item.dias_mora <= 60 ? 'bg-amber-50 text-amber-700 border border-amber-100' :
                                                            'bg-red-50 text-red-700 border border-red-100'
                                                        }`}>
                                                        {item.dias_mora}d
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5 text-center text-sm text-gray-600">
                                                    <span className="text-xs whitespace-nowrap font-medium text-gray-600">
                                                        {formatearFecha(item.desde)} - {formatearFecha(item.hasta)}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-5 text-center">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <button
                                                            onClick={() => handleEditar(item)}
                                                            className="inline-flex items-center px-3 py-2 rounded-full bg-blue-100 text-blue-700 hover:bg-blue-200 transition-all duration-200 font-semibold text-xs hover:scale-105"
                                                            title="Editar"
                                                        >
                                                            ✎ Editar
                                                        </button>
                                                        <button
                                                            onClick={() => handleEliminar(item.desde)}
                                                            className="inline-flex items-center px-3 py-2 rounded-full bg-red-100 text-red-700 hover:bg-red-200 transition-all duration-200 font-semibold text-xs hover:scale-105"
                                                            title="Eliminar"
                                                        >
                                                            🗑 Eliminar
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Modal Formulario */}
                <FormularioProtocolo
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onSubmit={handleSubmitProtocolo}
                    editData={editingData}
                    riesgoData={riesgoData}
                    accionesDisponibles={accionesDisponibles}
                />
            </div>
        </div>
    );
}
